export const capitalize = s => {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

export const capitalizeFirstLetter = str => {
    if (!str) return "";
    return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + (txt.substr(1) || '').toLowerCase();
    });
};

export const TitleCase = str => str.split(' ').map(w => `${w.charAt(0).toUpperCase()}${w.slice(1)}`).join(' ');

export const distinct = (array, prop) => {
    if (array === undefined) return [];
    const values = array.map(i => prop(i));
    return [...new Set(values)];
}

export const arrayGroupByFuncWithProjection = (array, groupingFunc, func) => {
    if (!array || array.length === 0) return [];

    const grouped = array.reduce((groups, item) => {
        const v = groupingFunc(item);

        groups[v] = groups[v] || [];
        groups[v].push(item);
        return groups;
    }, []);

    let result = [];

    for (let key in grouped) {
        if (grouped.hasOwnProperty(key)) {
            const newObj = func === undefined
                ? grouped[key][0]
                : func(key, grouped[key]);

            result.push(newObj);
        }
    }

    return result;
};

export const groupBy = (array, prop) => {
    return array.reduce((groups, item) => {

        const val = prop !== undefined
            ? item[prop]
            : item;

        if (val !== undefined) {
            groups[val] = groups[val] || [];
            groups[val].push(item);
        }
        return groups;
    }, {});
}

export const groupByAggregate = (array, prop, func) => {
    const grouped = groupBy(array, prop);
    let result = [];

    for (let key in grouped) {
        if (grouped.hasOwnProperty(key)) {
            const newObj = func === undefined
                ? grouped[key][0]
                : func(grouped[key]);

            result.push(newObj);
        }
    }

    return result;
}

export const minSqlDate = new Date('1753-01-01');
export const maxSqlDate = new Date('9999-12-31');
export const minSubmittedDate = new Date('2018-01-01');
export const minStartDate = new Date('2017-01-01');


export const isValidDate = (d) => {
    return d instanceof Date && !isNaN(d);
}

export const createValidDate = (s) => {
    if (!s) return new Date();
    else if (s.charAt(2) === '/' && s.charAt(5) === '/') {
        //take string of MM/DD/YYYY and convert to a valid js date
        const month = parseInt(s.substr(0, 2)) - 1; //month is zero-indexed
        const day = parseInt(s.substr(3, 2));
        const year = parseInt(s.substr(6, 4));
        return new Date(year, month, day);
    }
    else if (s.charAt(4) === '-' && s.charAt(7) === '-') {
        //take string of YYYY-MM-DD and convert to a valid js date
        const year = parseInt(s.substr(0, 4));
        const month = parseInt(s.substr(5, 2)) - 1; //month is zero-indexed
        const day = parseInt(s.substr(8, 2));
        return new Date(year, month, day);
    }
    else {
        return new Date();
    }
}

export const convertDateToString = (d) => {
    //take a valid js date and convert to a string of MM/DD/YYYY
    if (d instanceof Date && !isNaN(d)) {
        var day = d.getDate();
        var month = d.getMonth() + 1; //month is zero-indexed
        var year = d.getFullYear();
        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;
        return month + '/' + day + '/' + year;
    }
    else {
        return d
    }
}

export const matchedItems = (matches, a1, a2) => {
    const arrayMatches = Array.isArray(matches)
        ? matches
        : [matches];

    const indexes = arrayMatches.map(val => a1.indexOf(val));
    const results = indexes.map(i => a2[i]);
    return results;
}

export const stripNonNumeric = s => {
    if (typeof s === 'number') {
        return s;
    }
    else if (typeof s === 'string') {
        return s.replace(/\D/g, "");
    }
}

export const sum = (func) => (arr) => {
    return arr.reduce((tot, x) => tot + func(x), 0);
}

export const avg = (func) => (arr) => {
    const total = sum(func)(arr);
    return total / arr.length;
}

export const checkIfObjectIsEmpty = (obj) => !obj || (Object.keys(obj).length === 0 && obj.constructor === Object) || (obj.constructor === Array && obj.length === 0);

export const getObjectKeyByValue = (object, value) => Object.keys(object).find(key => object[key] === value);

export const isFunction = (obj) => !!(obj && obj.constructor && obj.call && obj.apply);

export const isJsonString = (str) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}


export const isGenentechPharmacyControlIncomplete = (data, pharmDictionary) => {
    const checkDrugPropsforEmpty = (drugObj, dictionary) => {
        return Object.keys(drugObj)
            .map(key => {
                if (dictionary[key] === null || drugObj['shipmentOption'] === 'Replacement') {
                    return false;
                }
                else return objectHasEmptyProp(drugObj[key], ['NumberOfTablets']);
            })
            .some(elem => elem === true)
    }

    return data.map(values => {
        if (values.shipmentOption === 'Replacement') return false;
        if (!values.prescriptionOption) return true;
        var dictEntry = pharmDictionary.find(dict => dict.drugName?.toLowerCase() === values.drugName?.toLowerCase());
        if (!dictEntry) return false;
        var dictionary = dictEntry.options
            .find(opt => (opt.prescriptionType === values.prescriptionType || (opt.prescriptionType === null && values.prescriptionType === ""))
                && opt.prescriptionOption === values.prescriptionOption);
        if (!dictionary) return false;
        return checkDrugPropsforEmpty(values, dictionary);
    }).some(elem => elem === true);
}

export const objectHasEmptyProp = (obj, exceptionKeys) => {
    var retVal = false;
    if (obj === undefined) return retVal;
    if (obj !== null && Array.isArray(obj)) {
        retVal = obj.map(elem => { return objectHasEmptyProp(elem, exceptionKeys) }).some(elem => elem === true);
    }
    else if (obj !== null && typeof obj === 'object') {
        retVal = Object.keys(obj).map(key => {
            if (exceptionKeys.includes(key)) return false;
            //if(key === 'NumberOfTablets') return false;
            else return objectHasEmptyProp(obj[key], [key]);
        }).some(elem => elem === true);
    }
    else if (isNaN(parseInt(obj)) && !obj) {
        retVal = true;
    }
    return retVal;
}
